import { ARBITER_PATH } from 'common/tags/zoidTagFromPathname'
import Zoid from 'common/modules/zoid'
import Retryer from 'common/retryer'

import generateStoreBundle from './store'

const retryer = new Retryer()

let store
let sagas

const startArbiter = async () => {
    try {
        const storeBundle = generateStoreBundle()

        store = storeBundle.store
        sagas = storeBundle.sagas

        store.dispatch(Zoid.creators.init({
            payload: {
                pathname: ARBITER_PATH,
            },
        }))

        return await sagas.toPromise()
    } catch (error) {
        if (retryer.canRetry()) {
            retryer.retry()

            const arbiterTask = await startArbiter()

            return arbiterTask
        }
        throw error
    }
}

(async () => {
    try {
        await startArbiter()
    } catch (error) {
        window?.xprops?.sendHostMessage('FRAME/ERROR')
    }
})()

if (module.hot) {
    module.hot.accept('./store', async () => {
        const { default: nextStoreBundle } = await import('./store')

        store.replaceReducer(nextStoreBundle.combinedReducers)
    })
}
